import { jsx as _jsx } from "react/jsx-runtime";
import { QueueContext } from './queue-context';
import TaskPanel from './TaskPanel';
const TasksList = ({ queue, tasks, onDeleteTask, }) => (_jsx("div", { className: "tasks-list", children: _jsx(QueueContext.Provider, { value: queue, children: tasks.map((task) => (_jsx(TaskPanel, { task: task, onDeleteTask: (id) => onDeleteTask(id) }, task.id))) }) }));
export default TasksList;
